import ArticleIcon from '@mui/icons-material/Article';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import * as theme from '../../../theme';
import { getDocumentUrl } from '../../../functions/storageUtils';
import { useState, useEffect } from 'react';

export default function AdditionalContentItem({ children, ...props }) {
  const [documentUrl, setDocumentUrl] = useState('');

  const getIcon = () => {
    if (props.icon) {
      if (props.icon === 'report') {
        return <ArticleIcon sx={{ flex: '0 0 auto', color: theme.Colors.Purple }} />;
      } else if (props.icon === 'video') {
        return <YouTubeIcon sx={{ flex: '0 0 auto', color: theme.Colors.Purple }} />;
      } else if (props.icon === 'pdf') {
        return <PictureAsPdfIcon sx={{ flex: '0 0 auto', color: theme.Colors.Purple }} />;
      }
    }
  };

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const url = await getDocumentUrl(props.label, 'private');
        setDocumentUrl(url);
      } catch (error) {
        console.error(error.message);
      }
    };

    if (props.icon === 'pdf') {
      fetchUrl();
    }
  }, []);

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ color: theme.Colors.Purple, display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.icon === 'pdf' ? window.open(documentUrl, '_blank') : props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          {getIcon()}
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.label}
          </div>
        </div>
      </div>
    </div>
  );
}